import React, {forwardRef} from 'react';
import ModalTemplate from "../../Wrappers/ModalTemplate";
import PasswordInput from "../../Atoms/Forms/PasswordInput";
import WarningGuy from "../../../static/images/stories/warning.svg"

const DeleteCompanyModal = forwardRef((props, ref) => {
  return (
    <ModalTemplate
      ref={ref}
      className="medium s-center s-main-center"
    >
      <h3>¿Seguro de que quieres eliminar esta empresa?</h3>
      <p>Al eliminar <span className="s-color-blue">Discord</span> perderás la información de todos los empleados y sus nóminas. Esta acción NO se puede revertir.</p>
      <img
        className="s-mb-24px"
        src={WarningGuy}
      />
      <div className="m-to-center m-60 l-block">
        <PasswordInput label="Ingresa tu contraseña para confirmar" />
      </div>
      <div className="buttons-container">
        <button className="button cancel">Cancelar</button>
        <button className="button delete" disabled>Elimina esta empresa</button>
      </div>
    </ModalTemplate>
  );
})

export default DeleteCompanyModal;
